import { Middleware, ResponseContext } from "@wingspanhq/wingspan-api-sdk";
import { mfaService } from "@services/mfaService";

const MFA_RETRY_HEADER = "X-WS-Mfa-Retried";

export const mfaChallengeMiddleware: Middleware = {
  post: async (context: ResponseContext): Promise<Response | void> => {
    if (new Headers(context.init.headers).has(MFA_RETRY_HEADER)) {
      return;
    }

    const requirement = await mfaService.getRequirement(context.response);
    if (!requirement) {
      return;
    }

    const verified = await mfaService.requestChallenge(requirement);
    if (!verified) {
      return;
    }

    const headers = new Headers(context.init.headers);
    headers.set(MFA_RETRY_HEADER, "1");

    return context.fetch(context.url, { ...context.init, headers });
  }
};
